import { Formik, FormikProps } from 'formik';
import React, { forwardRef } from 'react';
import { TransProps, useTranslation } from 'react-i18next';
import * as Yup from 'yup';

import { ValidationBarTheme } from '../../../enums';
import { DeliveryCompanyOrderFormData, FormFieldData } from '../../../interfaces';
import { ValidationBar } from '../../validationBar/validationBar.component';

import { deliveryCompanyOrderFormStructure } from './deliveryCompanyOrderForm.configs';
import { useDeliveryCompanyOrderFormValidation } from './deliveryCompanyOrderForm.hooks';
import { FormikForm, StyledFormField } from './deliveryCompanyOrderForm.styled';
import { DeliveryCompanyOrderFormProps } from './deliveryCompanyOrderForm.types';

export const DeliveryCompanyOrderForm: React.FC<DeliveryCompanyOrderFormProps> = forwardRef((
  props: DeliveryCompanyOrderFormProps, ref: React.Ref<FormikProps<DeliveryCompanyOrderFormData>>
): JSX.Element => {
  const { initialValues, isFormSubmitted, className }: DeliveryCompanyOrderFormProps = props;
  const deliveryCompanyOrderFormValidationSchema: Yup.SchemaOf<DeliveryCompanyOrderFormData> = useDeliveryCompanyOrderFormValidation();
  const { t }: TransProps<never> = useTranslation();

  return (
    <Formik
      className={className}
      initialValues={{ ...initialValues, country: 'Polska' }}
      onSubmit={(): void => undefined}
      innerRef={ref}
      validationSchema={deliveryCompanyOrderFormValidationSchema}
      validateOnChange={isFormSubmitted}
      validateOnBlur={isFormSubmitted}
      enableReinitialize
    >
      {({ handleSubmit, setFieldValue, errors, values }: FormikProps<DeliveryCompanyOrderFormData>): JSX.Element => (
        <FormikForm onSubmit={handleSubmit}>
          <ValidationBar
            barTheme={ValidationBarTheme.Information}
            message={t('onarte.ui.deliveryCompanyOrderForm.infoMessage')}
          />
          {deliveryCompanyOrderFormStructure.map((field: FormFieldData<keyof DeliveryCompanyOrderFormData>, index: number): JSX.Element => (
            <StyledFormField
              key={`${field.name}_${index}`}
              label={t(field.label ?? '')}
              fieldType={field.type}
              setFieldValue={setFieldValue}
              value={values[field.name] ?? ''}
              fieldName={field.name}
              validationMessage={isFormSubmitted ? errors[field.name] : undefined}
              withfullWidthFieldContainer={(field.name === 'street' || field.name === 'country')}
              $fullWidth={(field.name === 'street' || field.name === 'country')}
              disabled={field.disabled}
              additionalFieldProps={{...field.additionalFieldProps}}
            />
          ))}
        </FormikForm>
      )}
    </Formik>
  );
});
